<template>
    <div></div>
</template>

<script>
    import { mapState, mapMutations,mapActions } from 'vuex';

    export default {
        data() {
            return {
            }
        },
        mounted() {},
        methods: {
            ...mapMutations([
                'SET_BROKER_DATA',
                'SET_TOKEN_ID',
                'SET_LOADING',
                'SET_ACTIVE_STEP',
                'SET_INITIAL_DATA_LOADED'
            ]),
            ...mapActions([
                'brokerInit',
                'getPrescoring'
            ]),
            
            
        },
        computed:{
            ...mapState([
                'brokerData',
            ]),
        }

    }
</script>